import {useState} from 'react';
import messages from '../messages';
import {
  StoreColorRequest,
  useStoreColorMutation,
} from '../store/endpoints/store-color';
import {useListSlice} from 'features/table/slice';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {parseValidationErrors} from 'services/api/utils/parse-error';
import toast from 'store/ui/actions/toast';

const __DEV__ = process.env.NODE_ENV === 'development';

export const useColorForm = (onDismiss: () => void) => {
  const [storeColor, {isLoading, error}] = useStoreColorMutation();
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const serverError = parseValidationErrors(error);
  const {actions} = useListSlice();
  const name = 'colors';
  const url = 'colors';
  const handleSubmit = async () => {
    const result = await storeColor(params);
    if ('data' in result) {
      dispatch(toast('success', t(...messages.colorCreatedSuccess())));
      dispatch(actions.clearSelection(name));
      dispatch(actions.loadData({url, name}));
      onDismiss();
    }
  };

  const [params, setParams] = useState<Params>({
    name: {
      en: '',
      fr: '',
    },
    code: '',
  });

  return {
    setParams,
    params,
    isLoading,
    validationErrors: serverError.errors,
    errorMessage: serverError.message,
    submit: handleSubmit,
  };
};
type Params = StoreColorRequest;
